// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import openSans from "../Assets/OpenSans-Medium.ttf";

// import frame1 from "../Assets/frame1.png";
// import frame2 from "../Assets/frame2.png";
// import littleImage from "../Assets/Little_logo.jpg";
// import { FormatDateTime } from "../Components/CommonComponent/DateFormat";
// import { AiOutlineConsoleSql } from "react-icons/ai";

// let pageCount = 0;
// window.tripsHeading = [
//   "Sn.",
//   "Driver Name",
//   // "Trip Date",
//   "Start Date Time",
//   "End Date Time",
//   "Riders",
//   "Pickup Location",
//   "Drop Location",
//   "Trip km",
// ];

// window.scheduleTripsHeading = [
//   "Sn.",
//   "Driver Name",
//   // "Trip Date",
//   "Start Date Time",
//   "End Date Time",
//   "Guest Name",
//   "Pickup Location",
//   "Drop Location",
//   "Trip km",
// ];

// window.shiftsHeading = [
//   "Sn.",
//   "Driver Name",
//   "Scheduled Time",
//   "Actual Time",
//   "Shift Time",
//   "Shift km",
//   "Start Odometer",
//   "End Odometer",
//   "Total Trips",
//   "Trip Km",
// ];

// window.bookingRequestsHeading = [
//   "Sn.",
//   "Guest Name",
//   "Pickup Date",
//   "Drop Date",
//   "Vehicle Type",
//   "Driver Name",
//   "Pickup Location",
//   "Drop Location",
// ];

// const adHocHeading = [
//   "Sn.",
//   "Driver Name",
//   "Start Date Time",
//   "End Date Time",
//   "km",
// ];

// let months = [
//   "January",
//   "Febuary",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// const generatePDF = (
//   startDate,
//   endDate,
//   data,
//   riderName,
//   driverName,
//   tripsCount,
//   kmCount,
//   cpLogo,
//   cpAddress,
//   addressWidth,
//   isSchedueBooking,
//   type,
//   adHocDriverList
// ) => {
//   console.log("data in generatepdf", data);
//   console.log("cpLogo in generatepdf", cpLogo);

//   const opt = { orientation: "portrait", unit: "px", compressPdf: true };
//   const doc = new jsPDF(opt);
//   let current_date_time =
//     new Date().getMonth() +
//     1 +
//     "/" +
//     new Date().getDate() +
//     "/" +
//     new Date().getFullYear() +
//     " | " +
//     (new Date().getHours() > 12
//       ? new Date().getHours() -
//         12 +
//         ":" +
//         (new Date().getMinutes().toString().length === 1
//           ? "0" + new Date().getMinutes()
//           : new Date().getMinutes()) +
//         " pm"
//       : new Date().getHours() +
//         ":" +
//         (new Date().getMinutes().toString().length === 1
//           ? "0" + new Date().getMinutes()
//           : new Date().getMinutes()) +
//         " am");
//   pageCount = 0;
//   let tableColumn = [];
//   tableColumn = window[type + "Heading"];
//   const tableRows = [];

//   let i = 0,
//     j = 0;
//   const roundedKm = Math.ceil(kmCount * 10) / 10;
//   // const roundedKm = kmCount;
//   data?.ReportDetails?.forEach((ticket) => {
//     let ticketData = [];
//     if (type + "Heading" === "shiftsHeading")
//       ticketData = [
//         ++i,
//         ticket.DriverName,
//         FormatDateTime(ticket.StartTime) +
//           " to\n" +
//           FormatDateTime(ticket.EndTime),
//         !ticket.StartedOn
//           ? "-"
//           : FormatDateTime(ticket.StartedOn) +
//             " to\n" +
//             (ticket.EndedOn ? FormatDateTime(ticket.EndedOn) : "-"),
//         ticket.ShiftTime ? ticket.ShiftTime : "-",
//         // ticket.Totaltrip,

//         ticket.ShiftKM && !isNaN(ticket.ShiftKM) ? `${ticket.ShiftKM} Km` : "-",
//         ticket.StartOdometer && !isNaN(ticket.StartOdometer)
//           ? `${ticket.StartOdometer} Km`
//           : "-",
//         ticket.EndOdometer && !isNaN(ticket.EndOdometer)
//           ? `${ticket.EndOdometer} Km`
//           : "-",
//         ticket.TotalTrips ? ticket.TotalTrips : "-",
//         ticket.TotalTripKM && !isNaN(ticket.TotalTripKM)
//           ? `${Math.ceil(ticket.TotalTripKM).toFixed(0)} Km`
//           : "-",
//       ];
//     else if (type + "Heading" === "scheduleTripsHeading")
//       ticketData = [
//         ++i,
//         ticket.DriverName,
//         // ticket.StartedOnDate,
//         ticket.StartedOnTime,
//         ticket.EndedOnTime,
//         ticket.GuestName,
//         ticket.ActualPickupName
//           ? ticket.ActualPickupName
//           : ticket.PickupAddress,
//         ticket.ActualDropOffName
//           ? ticket.ActualDropOffName
//           : ticket.DropOffAddress,
//         // (parseInt(ticket.TripDistance) / 1000).toFixed(1),
//         // parseInt(ticket.TripDistance).toFixed(1),
//         Math.ceil(ticket.TripDistance).toFixed(0),
//       ];
//     else if (type + "Heading" === "tripsHeading")
//       ticketData = [
//         ++i,
//         ticket.DriverName + " " + ticket.CarNumber,
//         // ticket.TripDate,
//         FormatDateTime(ticket.StartTime),
//         FormatDateTime(ticket.EndTime),
//         ticket.RiderName,
//         ticket.ActualPickupName
//           ? ticket.ActualPickupName
//           : ticket.PickupAddress,
//         ticket.ActualDropOffName
//           ? ticket.ActualDropOffName
//           : ticket.DropOffAddress,
//         // parseInt(ticket.TripDistance).toFixed(2),
//         Math.ceil(ticket.TripDistance).toFixed(0),
//       ];
//     else if (type + "Heading" === "bookingRequestsHeading")
//       ticketData = [
//         ++i,
//         ticket.GuestName,
//         ticket.PickupDateTime,
//         ticket.DropOffDateTime,
//         ticket.VehicleType,
//         ticket.DriverName ? ticket.DriverName : "-",
//         ticket.PickupAddress,
//         ticket.DropoffAddress,
//       ];
//     tableRows.push(ticketData);
//   });

//   let adHocRows = [];
//   adHocDriverList?.forEach((ticket) => {
//     let ticketData = [];
//     ticketData = [
//       ++j,
//       ticket.DriverName,
//       ticket.StartTime.replace("T", " "),
//       ticket.EndTime.replace("T", " "),
//       ticket.kilometers,
//     ];
//     adHocRows.push(ticketData);
//   });

//   doc.addFont(openSans, "openSans", "normal");
//   doc.setFont("openSans");

//   if (isSchedueBooking != true) {
//     doc.setDrawColor(255, 255, 255);
//     doc.setFillColor(240, 240, 240);
//     doc.roundedRect(75, 58, 110, 40, 20, 20, "FD");
//     doc.addImage(frame2, "png", 80, 63, 30, 30);
//     doc.setFontSize(15);

//     doc.setTextColor(34, 137, 203);
//     doc.text(`${tripsCount}`, 120, 75);
//     doc.setFontSize(11);
//     doc.setTextColor(54, 69, 79);
//     {
//       type === "shifts"
//         ? doc.text("Shifts", 120, 87)
//         : doc.text("Trips", 120, 87);
//     }
//     // doc.text("Trips", 120, 87);

//     doc.setDrawColor(255, 255, 255);
//     doc.setFillColor(240, 240, 240);
//     doc.roundedRect(250, 58, 110, 40, 20, 20, "FD");
//     doc.addImage(frame1, "png", 255, 63, 30, 30);
//     doc.setFontSize(15);
//     doc.setTextColor(34, 137, 203);
//     doc.text(`${roundedKm.toFixed(1)}`, 295, 75);
//     // doc.text(`${(kmCount).toFixed(2)}`, 295, 75);

//     doc.setFontSize(11);
//     doc.setTextColor(54, 69, 79);
//     doc.text("Kilometers", 295, 87);
//   }

//   // const addressX = 320 - (doc.getStringUnitWidth(cpAddress) * doc.internal.getFontSize() / 2);

//   doc.setTextColor(0);
//   doc.setFontSize(10);
//   doc.autoTable(tableColumn, tableRows, {
//     didDrawPage: function (data) {
//       doc.setFont("openSans");
//       doc.setFontSize(8);
//       doc.text(
//         `${type === "shifts" ? "Shifts Statement" : "Trips Statement"}` +
//           (riderName ? ` of rider ${riderName}` : "") +
//           (driverName ? ` from driver ${driverName}` : "") +
//           (startDate
//             ? ` from ${startDate} to ${endDate}`
//             : // ` from ${startDate.split("-")[2] + " " + months[+startDate.split("-")[1] - 1] + " " + startDate.split("-")[0]} to ${endDate.split("-")[2] + " " + months[+endDate.split("-")[1] - 1] + " " + endDate.split("-")[0]}` :
//               ` till ${
//                 new Date().getDate() +
//                 " " +
//                 months[new Date().getMonth()] +
//                 " " +
//                 new Date().getFullYear()
//               }`),
//         30,
//         isSchedueBooking != true ? (pageCount === 0 ? 115 : 65) : 75
//       );
//       var img = new Image();
//       img.src = data?.CorporateLogo || cpLogo;
//       doc.addImage(data?.CorporateLogo || cpLogo, "png", 190, 10, 70, 32);
//       doc.setFontSize(6);
//       doc.setTextColor(54, 69, 79);
//       doc.text(cpAddress, doc.internal.pageSize.width / 2, 50, "center");

//       doc.addImage(data?.CorporateLogo || littleImage, "png", 10, 575, 45, 20);
//       doc.text(
//         "Printed by " + localStorage.getItem("adminName"),
//         450 -
//           (doc.getFontSize() *
//             ("Printed by " + localStorage.getItem("adminName")).length) /
//             2,
//         588
//       );
//       doc.text(
//         current_date_time,
//         448 - (doc.getFontSize() * current_date_time.length) / 2,
//         595
//       );
//       doc.setLineWidth(1);
//       doc.setDrawColor(42, 149, 69);
//       doc.line(10, 598, 117.5, 598);
//       doc.setDrawColor(34, 137, 203);
//       doc.line(117.5, 598, 225, 598);
//       doc.setDrawColor(226, 44, 29);
//       doc.line(225, 598, 332.5, 598);
//       doc.setDrawColor(245, 174, 48);
//       doc.line(332.5, 598, 440, 598);
//       doc.setFontSize(8);
//       doc.text("Page No. " + ++pageCount, 403, 608);
//     },
//     margin: { top: 70, bottom: 80 },
//     styles: { fontSize: 7, font: "openSans" },
//     // columnStyles: { 6: { columnWidth: 85 }, 7: { columnWidth: 85 }, },
//     startY: isSchedueBooking == true ? 80 : 120,
//     bodyStyles: { fontSize: 6 },
//     headStyles: { fillColor: [34, 137, 203] },
//   });
//   if (adHocRows.length > 0 && !driverName && !riderName) {
//     doc.addPage();
//     doc.text("Ad Hoc Driver Data", 30, 70);
//     doc.autoTable(adHocHeading, adHocRows, {
//       didDrawPage: function (data) {
//         doc.addImage(cpLogo, "png", 190, 10, 70, 32);
//         doc.setFontSize(6);
//         doc.setTextColor(54, 69, 79);
//         // doc.text(
//         //   cpAddress,
//         //   (450 - (doc.getFontSize() * addressWidth) / 12) / 2,
//         //   50
//         // );
//         doc.text(cpAddress, doc.internal.pageSize.width / 2, 50, "center");
//         doc.addImage(littleImage, "png", 10, 575, 45, 20);
//         doc.text(
//           "Printed by " + localStorage.getItem("adminName"),
//           450 -
//             (doc.getFontSize() *
//               ("Printed by " + localStorage.getItem("adminName")).length) /
//               2,
//           588
//         );
//         doc.text(
//           current_date_time,
//           448 - (doc.getFontSize() * current_date_time.length) / 2,
//           595
//         );
//         doc.setLineWidth(1);
//         doc.setDrawColor(42, 149, 69);
//         doc.line(10, 598, 117.5, 598);
//         doc.setDrawColor(34, 137, 203);
//         doc.line(117.5, 598, 225, 598);
//         doc.setDrawColor(226, 44, 29);
//         doc.line(225, 598, 332.5, 598);
//         doc.setDrawColor(245, 174, 48);
//         doc.line(332.5, 598, 440, 598);
//         doc.setFontSize(8);
//         doc.text("Page No. " + ++pageCount, 403, 608);
//       },
//       margin: { top: 70, bottom: 80 },
//       styles: { fontSize: 7, font: "openSans" },
//       startY: 80,
//       columnStyles: { 6: { columnWidth: 85 }, 7: { columnWidth: 85 } },
//       bodyStyles: { fontSize: 6 },
//       headStyles: { fillColor: [34, 137, 203] },
//     });
//   }

//   doc.output("dataurlnewwindow", { filename: "Report" });
// };

// export default generatePDF;

// ----------------------------------------------------------------------------------------------------------

import jsPDF from "jspdf";
import "jspdf-autotable";
import openSans from "../Assets/OpenSans-Medium.ttf";

import frame1 from "../Assets/frame1.png";
import frame2 from "../Assets/frame2.png";
import fuel from "../Assets/Fuel.png";
import bill from "../Assets/Bill.png";
import littleImage from "../Assets/Little_logo.jpg";
import { FormatDateTime } from "../Components/CommonComponent/DateFormat";
import { toast } from "react-toastify";

let pageCount = 0;
window.tripsHeading = [
  "Sn.",
  "Driver Name",
  "Start Date Time",
  "End Date Time",
  "Riders",
  "Pickup Location",
  "Drop Location",
  "Trip km",
];

window.scheduleTripsHeading = [
  "Sn.",
  "Driver Name",
  "Start Date Time",
  "End Date Time",
  "Guest Name",
  "Pickup Location",
  "Drop Location",
  "Trip km",
];

window.shiftsHeading = [
  "Sn.",
  "Driver Name",
  "Vehicle",
  "Scheduled Time",
  "Actual Time",
  "Shift Time",
  "Odometer",
  // "End Odometer",
  "Shift km",
  // "Trips",
  // "Trip Km",
];

window.fuelHeading = [
  "Sn.",
  "Date",
  "Odometer",
  // "Trip Meter",
  // "Vehicle Number",
  "Fuel Type",
  "Fuel",
  "Payment Mode",
  "Bill Amount",
  "Approved By",
];

window.vehicleReportHeading = [
  "Sn.",
  "Vehicle",
  "Start Date",
  "End Date",
  "Start Odometer",
  "End Odometer",
  "Days",
  "KM",
];

window.bookingRequestsHeading = [
  "Sn.",
  "Guest Name",
  "Pickup Date",
  "Drop Date",
  "Vehicle Type",
  "Driver Name",
  "Pickup Location",
  "Drop Location",
];

const adHocHeading = [
  "Sn.",
  "Driver Name",
  "Start Date Time",
  "End Date Time",
  "km",
];

let months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// Helper function to wrap long cancel reason text into two lines
const wrapCancelReason = (text, maxLength = 35) => {
  if (!text || text.length <= maxLength) {
    return text;
  }
  
  // Try to split at a space near the middle
  const midPoint = Math.floor(text.length / 2);
  let splitIndex = midPoint;
  
  // Find the nearest space before the midpoint
  for (let i = midPoint; i >= 0 && i > midPoint - 15; i--) {
    if (text[i] === ' ') {
      splitIndex = i;
      break;
    }
  }
  
  // If no space found, try finding space after midpoint
  if (splitIndex === midPoint) {
    for (let i = midPoint; i < text.length && i < midPoint + 15; i++) {
      if (text[i] === ' ') {
        splitIndex = i;
        break;
      }
    }
  }
  
  // Split the text at the found index
  const firstLine = text.substring(0, splitIndex).trim();
  const secondLine = text.substring(splitIndex).trim();
  
  return firstLine + "\n" + secondLine;
};

const resolvePdfLogo = async (corporateLogoUrl) => {
  if (!corporateLogoUrl || typeof corporateLogoUrl !== "string") {
    return littleImage;
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    const response = await fetch(corporateLogoUrl, {
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      return littleImage;
    }

    const blob = await response.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result || littleImage);
      reader.onerror = () => resolve(littleImage);
      reader.readAsDataURL(blob);
    });
  } catch {
    return littleImage;
  }
};

const openPdfInNewTab = (url) => {
  const pdfWindow = window.open("", "_blank");

  if (!pdfWindow) {
    return false;
  }

  pdfWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Report</title>
        <style>
          html, body { margin: 0; padding: 0; height: 100%; }
          embed { width: 100%; height: 100%; }
        </style>
      </head>
      <body>
        <embed src="${url}" type="application/pdf" />
      </body>
    </html>
  `);
  pdfWindow.document.close();

  return true;
};

const outputPdf = (doc) => {
  try {
    const blob = doc.output("blob");

    // Large reports (e.g. 3000+ trips) exceed browser data-URL limits.
    // Blob URL or direct download handles them reliably.
    if (blob.size > 2 * 1024 * 1024) {
      doc.save("Report.pdf");
      toast.info("Large report — PDF downloaded to your device.");
      return "download";
    }

    const url = URL.createObjectURL(blob);
    const opened = openPdfInNewTab(url);

    if (!opened) {
      URL.revokeObjectURL(url);
      doc.save("Report.pdf");
      return "download";
    }

    setTimeout(() => URL.revokeObjectURL(url), 120000);
    return "open";
  } catch (error) {
    console.error("PDF output failed, using download fallback:", error);
    doc.save("Report.pdf");
    return "download-fallback";
  }
};

const generatePDF = async (
  startDate,
  endDate,
  data,
  riderName,
  driverName,
  tripsCount,
  kmCount,
  cpLogo,
  cpAddress,
  addressWidth,
  isSchedueBooking,
  type,
  adHocDriverList
) => {
  try {
    const headerLogo = await resolvePdfLogo(data?.CorporateLogo);

    // Allow the loading UI to paint before heavy PDF work
    await new Promise((resolve) => setTimeout(resolve, 0));

    const regNumber = data?.RegNumber;
  const opt = { orientation: "portrait", unit: "px", compressPdf: true };
  const doc = new jsPDF(opt);
  let current_date_time =
    new Date().getMonth() +
    1 +
    "/" +
    new Date().getDate() +
    "/" +
    new Date().getFullYear() +
    " | " +
    (new Date().getHours() > 12
      ? new Date().getHours() -
        12 +
        ":" +
        (new Date().getMinutes().toString().length === 1
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()) +
        " pm"
      : new Date().getHours() +
        ":" +
        (new Date().getMinutes().toString().length === 1
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()) +
        " am");
  pageCount = 0;
  let tableColumn = [];
  tableColumn = window[type + "Heading"];
  const tableRows = [];

  let i = 0,
    j = 0;
  const roundedKm = Math.ceil(kmCount * 10) / 10;
  const BillAmount = data.BillAmount;

  data?.ReportDetails?.forEach((ticket) => {
    let ticketData = [];
    if (type + "Heading" === "shiftsHeading")
      ticketData = [
        ++i,
        ticket.DriverName,
        ticket.RegNumber
          ? ticket.RegNumber
          : ticket.AssignedVehicleToDriver
          ? ticket.AssignedVehicleToDriver
          : "-",
        FormatDateTime(ticket.StartTime) +
          " to\n" +
          FormatDateTime(ticket.EndTime),
        !ticket.StartedOn
          ? "-"
          : FormatDateTime(ticket.StartedOn) +
            " to\n" +
            (ticket.EndedOn ? FormatDateTime(ticket.EndedOn) : "-"),
        ticket.ShiftTime ? ticket.ShiftTime : "-",
        // ticket.StartOdometer && !isNaN(ticket.StartOdometer)
        //   ? `${ticket.StartOdometer}`
        //   : "-",
        // ticket.EndOdometer && !isNaN(ticket.EndOdometer)
        //   ? `${ticket.EndOdometer}`
        //   : "-",
        (ticket.StartOdometer && !isNaN(ticket.StartOdometer)) || (ticket.EndOdometer && !isNaN(ticket.EndOdometer))
          ? `${ticket.StartOdometer && !isNaN(ticket.StartOdometer) ? ticket.StartOdometer : "-"} to\n${ticket.EndOdometer && !isNaN(ticket.EndOdometer) ? ticket.EndOdometer : "-"}`
          : "-",
        ticket.CancelReason && ticket.CancelReason !== null && ticket.CancelReason !== ""
          ? wrapCancelReason(ticket.CancelReason)
          : ticket.ShiftKM && !isNaN(ticket.ShiftKM) ? `${ticket.ShiftKM} Km` : "-",
        // ticket.TotalTrips ? ticket.TotalTrips : "-",
        // ticket.TotalTripKM && !isNaN(ticket.TotalTripKM)
        //   ? `${Math.ceil(ticket.TotalTripKM).toFixed(0)} Km`
        //   : "-",
      ];
    else if (type + "Heading" === "scheduleTripsHeading")
      ticketData = [
        ++i,
        ticket.DriverName,
        ticket.StartedOnTime,
        ticket.EndedOnTime,
        ticket.GuestName,
        ticket.ActualPickupName
          ? ticket.ActualPickupName
          : ticket.PickupAddress,
        ticket.ActualDropOffName
          ? ticket.ActualDropOffName
          : ticket.DropOffAddress,
        Math.ceil(ticket.TripDistance).toFixed(0),
      ];
    else if (type + "Heading" === "tripsHeading")
      ticketData = [
        ++i,
        ticket.DriverName + " " + ticket.CarNumber,
        FormatDateTime(ticket.StartTime),
        FormatDateTime(ticket.EndTime),
        ticket.RiderName,
        ticket.ActualPickupName
          ? ticket.ActualPickupName
          : ticket.PickupAddress,
        ticket.ActualDropOffName
          ? ticket.ActualDropOffName
          : ticket.DropOffAddress,
        Math.ceil(ticket.TripDistance).toFixed(0),
      ];
    else if (type + "Heading" === "bookingRequestsHeading")
      ticketData = [
        ++i,
        ticket.GuestName,
        ticket.PickupDateTime,
        ticket.DropOffDateTime,
        ticket.VehicleType,
        ticket.DriverName ? ticket.DriverName : "-",
        ticket.PickupAddress,
        ticket.DropoffAddress,
      ];
    else if (type + "Heading" === "fuelHeading")
      ticketData = [
        ++i,
        FormatDateTime(ticket.Date),
        ticket.Odometer && !isNaN(ticket.Odometer)
          ? `${ticket.Odometer} Km`
          : "-",
        ticket.FuelType ? ticket.FuelType : "-",
        ticket.Fuel,
        ticket.PaymentType ? ticket.PaymentType : "-",
        ticket.BillAmount ? ticket.BillAmount : "-",
        ticket.ApprovedBy ? ticket.ApprovedBy : "-",
      ];
    else if (type + "Heading" === "vehicleReportHeading")
      ticketData = [
        ++i,
        ticket.Vehicle || "-",
        ticket.StartDate || "-",
        ticket.EndDate || "-",
        ticket.StartOdometer != null ? ticket.StartOdometer : "-",
        ticket.EndOdometer != null ? ticket.EndOdometer : "-",
        ticket.Days != null ? ticket.Days : "-",
        ticket.DifferenceKm != null ? `${ticket.DifferenceKm} Km` : "-",
      ];

    tableRows.push(ticketData);
  });

  let adHocRows = [];
  adHocDriverList?.forEach((ticket) => {
    let ticketData = [];
    ticketData = [
      ++j,
      ticket.DriverName,
      ticket.StartTime.replace("T", " "),
      ticket.EndTime.replace("T", " "),
      ticket.kilometers,
    ];
    adHocRows.push(ticketData);
  });

  doc.addFont(openSans, "openSans", "normal");
  doc.setFont("openSans");

  // if (isSchedueBooking != true) {
  //   doc.setDrawColor(255, 255, 255);
  //   doc.setFillColor(240, 240, 240);
  //   doc.roundedRect(75, 58, 110, 40, 20, 20, "FD");
  //   doc.addImage(frame2, "png", 80, 63, 30, 30);
  //   doc.setFontSize(15);

  //   doc.setTextColor(34, 137, 203);
  //   doc.text(`${tripsCount}`, 120, 75);
  //   doc.setFontSize(11);
  //   doc.setTextColor(54, 69, 79);

  //   type === "shifts"
  //     ? doc.text("Shifts", 120, 87)
  //     : type === "fuel"
  //     ? doc.text("Bill", 120, 87)
  //     : doc.text("Trips", 120, 87);

  //   doc.setDrawColor(255, 255, 255);
  //   doc.setFillColor(240, 240, 240);
  //   doc.roundedRect(250, 58, 110, 40, 20, 20, "FD");
  //   doc.addImage(frame1, "png", 255, 63, 30, 30);
  //   doc.setFontSize(15);
  //   doc.setTextColor(34, 137, 203);
  //   type === "fuel"
  //     ? doc.text(`${kmCount}`, 295, 75)
  //     : doc.text(`${parseInt(roundedKm)?.toFixed(1)}`, 295, 75);

  //   doc.setFontSize(11);
  //   doc.setTextColor(54, 69, 79);
  //   type === "fuel"
  //     ? doc.text("Average", 295, 87)
  //     : doc.text("Kilometers", 295, 87);
  // }

  doc.addFont(openSans, "openSans", "normal");
  doc.setFont("openSans");

  // if (isSchedueBooking != true) {
  //   // First header (left) - Bill Amount
  //   doc.setDrawColor(255, 255, 255);
  //   doc.setFillColor(240, 240, 240);
  //   doc.roundedRect(50, 58, 90, 40, 20, 20, "FD"); // Adjusted position and width
  //   doc.addImage(frame2, "png", 55, 63, 30, 30);
  //   doc.setFontSize(15);
  //   doc.setTextColor(34, 137, 203);
  //   type === "fuel"
  //     ? doc.text(`${parseFloat(data?.TotalBillAmount)}`, 85, 75)
  //     : doc.text(`${tripsCount}`, 85, 75);
  //   doc.setFontSize(11);
  //   doc.setTextColor(54, 69, 79);
  //   type === "fuel"
  //     ? doc.text("Bill", 85, 87)
  //     : type === "shifts"
  //     ? doc.text("Shifts", 85, 87)
  //     : doc.text("Trips", 85, 87);

  //   // Second header (middle) - Average Consumption
  //   doc.setDrawColor(255, 255, 255);
  //   doc.setFillColor(240, 240, 240);
  //   doc.roundedRect(170, 58, 90, 40, 20, 20, "FD"); // Adjusted position
  //   doc.addImage(frame1, "png", 175, 63, 30, 30);
  //   doc.setFontSize(15);
  //   doc.setTextColor(34, 137, 203);
  //   type === "fuel"
  //     ? doc.text(`${parseFloat(data?.AverageConsumption).toFixed(2)}`, 200, 75)
  //     : doc.text(`${parseInt(roundedKm)?.toFixed(1)}`, 200, 75);
  //   doc.setFontSize(11);
  //   doc.setTextColor(54, 69, 79);
  //   type === "fuel"
  //     ? doc.text("Average", 200, 87)
  //     : doc.text("Kilometers", 200, 87);

  //   // Third header (right) - Total Fuel (only for fuel reports)
  //   if (type === "fuel") {
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(290, 58, 90, 40, 20, 20, "FD");
  //     // You can use frame1 or frame2, or add a third image if needed
  //     doc.addImage(frame1, "png", 295, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${data.TotalFuel}`, 320, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Fuel", 320, 87);
  //   }
  // }

  // ------------------------------------------------------

  // if (isSchedueBooking != true) {
  //   if (type === "fuel") {
  //     // Fuel report specific headers (3 columns with adjusted spacing)

  //     // 1. Bill Amount (left)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(50, 58, 90, 40, 20, 20, "FD");
  //     doc.addImage(bill, "png", 55, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${parseFloat(data?.TotalBillAmount)}`, 90, 75); // 35px right of image
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Bill", 90, 87);

  //     // 2. Average Consumption (middle)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(170, 58, 90, 40, 20, 20, "FD");
  //     doc.addImage(frame1, "png", 175, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${parseFloat(data?.AverageConsumption).toFixed(2)}`, 210, 75); // 35px right
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Average", 210, 87);

  //     // 3. Total Fuel (right)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(290, 58, 90, 40, 20, 20, "FD");
  //     doc.addImage(fuel, "png", 295, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${data.TotalFuel}`, 330, 75); // 35px right
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Fuel", 330, 87);

  //   } else {
  //     // Original two-header layout for other report types
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(75, 58, 110, 40, 20, 20, "FD");
  //     doc.addImage(frame2, "png", 80, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${tripsCount}`, 120, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     type === "shifts"
  //       ? doc.text("Shifts", 120, 87)
  //       : doc.text("Trips", 120, 87);

  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(250, 58, 110, 40, 20, 20, "FD");
  //     doc.addImage(frame1, "png", 255, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${parseInt(roundedKm)?.toFixed(1)}`, 295, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Kilometers", 295, 87);
  //   }
  // }

  // 2-----------------------------------------------------------------------

  // if (isSchedueBooking != true) {
  //   if (type === "fuel") {
  //     // Fuel report specific headers (4 columns with adjusted spacing)
  //     const boxWidth = 80; // Slightly narrower boxes to fit 4 in the page
  //     const startX = 30; // Starting position
  //     const gap = 10; // Gap between boxes

  //     // 1. Bill Amount (first column)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(startX, 58, boxWidth, 40, 20, 20, "FD");
  //     doc.addImage(bill, "png", startX + 5, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${parseFloat(data?.TotalBillAmount)}`, startX + 40, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Bill", startX + 40, 87);

  //     // 2. Average Consumption (second column)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(startX + boxWidth + gap, 58, boxWidth, 40, 20, 20, "FD");
  //     doc.addImage(frame1, "png", startX + boxWidth + gap + 5, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(
  //       `${parseFloat(data?.AverageConsumption).toFixed(2)}`,
  //       startX + boxWidth + gap + 40,
  //       75
  //     );
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Average", startX + boxWidth + gap + 40, 87);

  //     // 3. Total Fuel (third column)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(
  //       startX + (boxWidth + gap) * 2,
  //       58,
  //       boxWidth,
  //       40,
  //       20,
  //       20,
  //       "FD"
  //     );
  //     doc.addImage(fuel, "png", startX + (boxWidth + gap) * 2 + 5, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${data.TotalFuel}`, startX + (boxWidth + gap) * 2 + 40, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Fuel", startX + (boxWidth + gap) * 2 + 40, 87);

  //     // 4. Total Km (fourth column)
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(
  //       startX + (boxWidth + gap) * 3,
  //       58,
  //       boxWidth,
  //       40,
  //       20,
  //       20,
  //       "FD"
  //     );
  //     doc.addImage(
  //       frame2,
  //       "png",
  //       startX + (boxWidth + gap) * 3 + 5,
  //       63,
  //       30,
  //       30
  //     ); // Using frame1 image or you can add another image
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${data?.TotalKm}`, startX + (boxWidth + gap) * 3 + 40, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Total Km", startX + (boxWidth + gap) * 3 + 40, 87);
  //   } else {
  //     // Original two-header layout for other report types
  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(75, 58, 110, 40, 20, 20, "FD");
  //     doc.addImage(frame2, "png", 80, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${tripsCount}`, 120, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     type === "shifts"
  //       ? doc.text("Shifts", 120, 87)
  //       : doc.text("Trips", 120, 87);

  //     doc.setDrawColor(255, 255, 255);
  //     doc.setFillColor(240, 240, 240);
  //     doc.roundedRect(250, 58, 110, 40, 20, 20, "FD");
  //     doc.addImage(frame1, "png", 255, 63, 30, 30);
  //     doc.setFontSize(15);
  //     doc.setTextColor(34, 137, 203);
  //     doc.text(`${parseInt(roundedKm)?.toFixed(1)}`, 295, 75);
  //     doc.setFontSize(11);
  //     doc.setTextColor(54, 69, 79);
  //     doc.text("Kilometers", 295, 87);
  //   }
  // }

  if (isSchedueBooking != true) {
    if (type === "fuel") {
      // Fuel report specific headers (4 evenly spaced columns)
      const totalWidth = doc.internal.pageSize.width - 60; // Total available width (with 30px margins on each side)
      const boxCount = 4;
      const gap = 15; // Consistent gap between boxes
      const boxWidth = (totalWidth - gap * (boxCount - 1)) / boxCount;

      // Starting position (30px from left edge)
      let currentX = 30;

      // Common settings for all boxes
      const iconSize = 30;
      const iconPadding = 10; // Space between icon and text
      const textStartX = iconSize + iconPadding; // X position where text starts
      const centerOffset = (boxWidth - iconSize - iconPadding) / 2; // Center alignment offset

      // 1. Total Km
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(currentX, 58, boxWidth, 40, 20, 20, "FD");
      doc.addImage(frame2, "png", currentX + 5, 63, iconSize, iconSize);
      doc.setFontSize(15);
      doc.setTextColor(34, 137, 203);
      doc.text(`${data?.TotalKm}`, currentX + 5 + iconSize + iconPadding, 75);
      doc.setFontSize(11);
      doc.setTextColor(54, 69, 79);
      doc.text("KM", currentX + 5 + iconSize + iconPadding, 87);
      currentX += boxWidth + gap;

      // 2. Total Fuel
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(currentX, 58, boxWidth, 40, 20, 20, "FD");
      doc.addImage(fuel, "png", currentX + 5, 63, iconSize, iconSize);
      doc.setFontSize(15);
      doc.setTextColor(34, 137, 203);
      doc.text(
        `${parseFloat(data.TotalFuel).toFixed(1)}`,
        currentX + 5 + iconSize + iconPadding,
        75
      );
      doc.setFontSize(11);
      doc.setTextColor(54, 69, 79);
      doc.text("Fuel", currentX + 5 + iconSize + iconPadding, 87);
      currentX += boxWidth + gap;

      // 3. Average Consumption
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(currentX, 58, boxWidth, 40, 20, 20, "FD");
      doc.addImage(frame1, "png", currentX + 5, 63, iconSize, iconSize);
      doc.setFontSize(15);
      doc.setTextColor(34, 137, 203);
      doc.text(
        `${parseFloat(data?.AverageConsumption).toFixed(1)}`,
        currentX + 5 + iconSize + iconPadding,
        75
      );
      doc.setFontSize(11);
      doc.setTextColor(54, 69, 79);
      doc.text("Average", currentX + 5 + iconSize + iconPadding, 87);
      currentX += boxWidth + gap;

      // 4. Bill Amount
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(currentX, 58, boxWidth, 40, 20, 20, "FD");
      doc.addImage(bill, "png", currentX + 5, 63, iconSize, iconSize); // Fixed 10px left padding for icon
      doc.setFontSize(15);
      doc.setTextColor(34, 137, 203);
      doc.text(
        `${parseFloat(data?.TotalBillAmount)}`,
        currentX + 5 + iconSize + iconPadding,
        75
      );
      doc.setFontSize(11);
      doc.setTextColor(54, 69, 79);
      doc.text("Bill", currentX + 5 + iconSize + iconPadding, 87);
      // currentX += boxWidth + gap;
    } else {
      // Two-header layout for shifts, trips, and vehicleReport
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(75, 58, 110, 40, 20, 20, "FD");
      doc.addImage(frame2, "png", 80, 63, 30, 30);
      doc.setFontSize(15);
      doc.setTextColor(34, 137, 203);
      doc.text(`${tripsCount}`, 120, 75);
      doc.setFontSize(11);
      doc.setTextColor(54, 69, 79);
      type === "shifts"
        ? doc.text("Shifts", 120, 87)
        : type === "vehicleReport"
        ? doc.text("Vehicles", 120, 87)
        : doc.text("Trips", 120, 87);

      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(250, 58, 110, 40, 20, 20, "FD");
      doc.addImage(frame1, "png", 255, 63, 30, 30);
      doc.setFontSize(15);
      doc.setTextColor(34, 137, 203);
      doc.text(`${parseInt(roundedKm)?.toFixed(1)}`, 295, 75);
      doc.setFontSize(11);
      doc.setTextColor(54, 69, 79);
      doc.text("Kilometers", 295, 87);
    }
  }

  doc.setTextColor(0);
  doc.setFontSize(10);
  doc.autoTable(tableColumn, tableRows, {
    didDrawPage: function (data) {
      doc.setFont("openSans");
      doc.setFontSize(8);
      doc.text(
        `${
          type === "shifts"
            ? "Shifts Statement"
            : type === "fuel"
            ? `Fuel Statement for ${regNumber}`
            : type === "vehicleReport"
            ? "Vehicle Report"
            : "Trips Statement"
        }` +
          (riderName ? ` of rider ${riderName}` : "") +
          (driverName ? ` from driver ${driverName}` : "") +
          (startDate
            ? ` from ${startDate} to ${endDate}`
            : ` till ${
                new Date().getDate() +
                " " +
                months[new Date().getMonth()] +
                " " +
                new Date().getFullYear()
              }`),
        30,
        isSchedueBooking != true ? (pageCount === 0 ? 115 : 65) : 75
      );

      try {
        doc.addImage(headerLogo, "PNG", 190, 10, 70, 32);
      } catch (error) {
        console.error("Error loading header logo:", error);
        doc.addImage(littleImage, "JPEG", 190, 10, 70, 32);
      }

      doc.setFontSize(6);
      doc.setTextColor(54, 69, 79);
      doc.text(cpAddress, doc.internal.pageSize.width / 2, 50, "center");

      // Keep littleImage for footer
      doc.addImage(littleImage, "JPEG", 10, 575, 45, 20);
      doc.text(
        "Printed by " + localStorage.getItem("adminName"),
        450 -
          (doc.getFontSize() *
            ("Printed by " + localStorage.getItem("adminName")).length) /
            2,
        588
      );
      doc.text(
        current_date_time,
        448 - (doc.getFontSize() * current_date_time.length) / 2,
        595
      );
      doc.setLineWidth(1);
      doc.setDrawColor(42, 149, 69);
      doc.line(10, 598, 117.5, 598);
      doc.setDrawColor(34, 137, 203);
      doc.line(117.5, 598, 225, 598);
      doc.setDrawColor(226, 44, 29);
      doc.line(225, 598, 332.5, 598);
      doc.setDrawColor(245, 174, 48);
      doc.line(332.5, 598, 440, 598);
      doc.setFontSize(8);
      doc.text("Page No. " + ++pageCount, 403, 608);
    },
    margin: { top: 70, bottom: 80 },
    styles: { fontSize: 7, font: "openSans" },
    startY: isSchedueBooking == true ? 80 : 120,
    bodyStyles: { fontSize: 6 },
    headStyles: { fillColor: [34, 137, 203] },
  });

  if (adHocRows.length > 0 && !driverName && !riderName) {
    doc.addPage();
    doc.text("Ad Hoc Driver Data", 30, 70);
    doc.autoTable(adHocHeading, adHocRows, {
      didDrawPage: function () {
        try {
          doc.addImage(headerLogo, "PNG", 190, 10, 70, 32);
        } catch (error) {
          console.error("Error loading header logo:", error);
          doc.addImage(littleImage, "JPEG", 190, 10, 70, 32);
        }

        doc.setFontSize(6);
        doc.setTextColor(54, 69, 79);
        doc.text(cpAddress, doc.internal.pageSize.width / 2, 50, "center");
        doc.addImage(littleImage, "JPEG", 10, 575, 45, 20);
        doc.text(
          "Printed by " + localStorage.getItem("adminName"),
          450 -
            (doc.getFontSize() *
              ("Printed by " + localStorage.getItem("adminName")).length) /
              2,
          588
        );
        doc.text(
          current_date_time,
          448 - (doc.getFontSize() * current_date_time.length) / 2,
          595
        );
        doc.setLineWidth(1);
        doc.setDrawColor(42, 149, 69);
        doc.line(10, 598, 117.5, 598);
        doc.setDrawColor(34, 137, 203);
        doc.line(117.5, 598, 225, 598);
        doc.setDrawColor(226, 44, 29);
        doc.line(225, 598, 332.5, 598);
        doc.setDrawColor(245, 174, 48);
        doc.line(332.5, 598, 440, 598);
        doc.setFontSize(8);
        doc.text("Page No. " + ++pageCount, 403, 608);
      },
      margin: { top: 70, bottom: 80 },
      styles: { fontSize: 7, font: "openSans" },
      startY: 80,
      columnStyles: { 6: { columnWidth: 85 }, 7: { columnWidth: 85 } },
      bodyStyles: { fontSize: 6 },
      headStyles: { fillColor: [34, 137, 203] },
    });
  }

    outputPdf(doc);
  } catch (error) {
    console.error("PDF generation failed:", error);
    throw new Error(
      error?.message ||
        "Failed to generate PDF. The report may be too large — try a shorter date range."
    );
  }
};

export default generatePDF;
